import 'typeface-roboto';
import './index.css';

import { QueryClientProvider } from '@tanstack/react-query';
import { Amplify } from 'aws-amplify';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import queryClient from './lib/queryClient';

Amplify.configure({
  Auth: {
    region: 'us-east-1',
    userPoolId: process.env.REACT_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
    endpoint: process.env.REACT_APP_AUTH_ENDPOINT
  }
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  // The provider has to sit above App: App itself calls hooks that use react-query,
  // and a component can't consume a context it renders in its own JSX.
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </QueryClientProvider>
);
